<template>
	<div id="body">
		<div class="overlay">
			<div class="container">
				<div class="row">
					<div class="col-md-6 col-sm-6">
						<div class="page-title wow bounceInLeft animated animated" ata-wow-delay="0.4s" style="visibility: visible; animation-name: bounceInLeft;">
							<h1>{{home}}</h1></div>
					</div>
					<div class="col-md-6 col-sm-6">
						<ul class="page-breadcrumb wow bounceInRight animated animated" ata-wow-delay="0.4s" style="visibility: visible; animation-name: bounceInRight;">
							<li>
								<router-link to="/index">{{lang == 1 ? '首页' : 'Home'}}</router-link>
							</li>
							<li class="active">
								<router-link to="/contact_us">{{home}}</router-link>
							</li>
						</ul>
					</div>
				</div>
			</div>
		</div>
		<div class="page-seperate"></div>
		<div class="clearfix"></div>
		<!-- Blog & Sidebar Section -->
		<div id="content">
			<section class="blog-section">
				<div class="container">
					<div class="row">
						<!--Blog Section-->
						<div class="col-md-8 col-sm-7col-xs-12">
							<article id="post-21" class="post post-content-area wow fadeInDown animated post-21 page type-page status-publish hentry" data-wow-delay="0.4s">
								<div class="post-content">
									<div class="entry-content">
										<div role="form" class="wpcf7" id="wpcf7-f43-p21-o1" lang="zh-CN" dir="ltr">
											<div class="screen-reader-response" role="alert" aria-live="polite"></div>
											<form action="" method="post" id="submit" name="form1" class="wpcf7-form init" enctype="multipart/form-data" novalidate="novalidate">
												<p>
													<label> {{lang == 1 ? '您的名字/Your Name' : 'Your Name'}}： (required)<br />
	    												<span class="wpcf7-form-control-wrap your-name">
	    													<input type="text" name="name" value="" size="40" class="wpcf7-form-control wpcf7-text wpcf7-validates-as-required" aria-required="true" aria-invalid="false" />
	    												</span>
													</label>
												</p>
												<p>
													<label> {{lang == 1 ? '邮箱地址/Email Address' : 'Email Address'}}： (required)<br />
	    												<span class="wpcf7-form-control-wrap your-email">
	    													<input type="email" name="email" value="" size="40" class="wpcf7-form-control wpcf7-text wpcf7-email wpcf7-validates-as-required wpcf7-validates-as-email" aria-required="true" aria-invalid="false" />
	    												</span>
													</label>
												</p>
												<p>
													<label> {{lang == 1 ? '联系电话/Phone Number' : 'Phone Number'}}： (required)<br />
														<span class="wpcf7-form-control-wrap tel-560">
															<input type="tel" name="phone" value="" size="40" class="wpcf7-form-control wpcf7-text wpcf7-tel wpcf7-validates-as-required wpcf7-validates-as-tel" aria-required="true" aria-invalid="false" />
														</span>
													</label>
												</p>
												<p>
													<label> {{lang == 1 ? '您的公司或组织名称/Company or Organization Name' : 'Company or Organization Name'}}：<br />
	    												<span class="wpcf7-form-control-wrap your-subject">
	    													<input type="text" name="company" value="" size="40" class="wpcf7-form-control wpcf7-text" aria-invalid="false" />
	    												</span>
													</label>
												</p>
												<p>
													<label> {{lang == 1 ? '留言/Message' : 'Message'}}：<br />
	    												<span class="wpcf7-form-control-wrap your-message">
	    													<textarea name="message" cols="40" rows="10" class="wpcf7-form-control wpcf7-textarea" aria-invalid="false"></textarea>
	    												</span>
													</label>
												</p>
												<p>
													<label> {{lang == 1 ? '附件/Attachment' : 'Attachment'}}：<br />
														<span class="wpcf7-form-control-wrap file-943" style="display: flex;">
															<input type="file" style="position: fixed;top: -10000px;" id="upload" name="upload" onChange="document.form1.path.value=this.value" accept=".jpg,.jpeg,.png,.gif,.pdf,.doc,.docx,.ppt,.pptx,.odt,.avi,.ogg,.m4a,.mov,.mp3,.mp4,.mpg,.wav,.wmv" aria-invalid="false" />
															<input type="button" class="uploadbtn" onclick="document.form1.upload.click()" :value="lang == 1 ? '附件' : 'Attachment'" />
															<input type="text" class="uploadval" name="path" readonly :value="lang == 1 ? '未选择任何文件' : 'No files were selected'" />
														</span>
													</label>
												</p>
												<p>
													<input type="submit" value="Send" class="wpcf7-form-control wpcf7-submit" />
												</p>
												<div class="wpcf7-response-output" role="alert" aria-hidden="true"></div>
												<input type="hidden" readonly="readonly" id="attachment" name="attachment" value="" />
											</form>
										</div>
									</div>
								</div>
							</article>
						</div>
						<!--/Blog Section-->

						<!--Sidebar Section-->
						<div class="col-md-4 col-sm-5 col-xs-12">
							<div class="sidebar">
								<aside id="search-1" class="widget widget_search wow fadeInDown animated" data-wow-delay="0.4s">
									<div class="section-header wow fadeInDown animated" data-wow-delay="0.4s">
										<h3 class="widget-title">Search</h3></div>
									<form method="get" id="searchform" class="search-form" action="" ref="form">
										<label><input type="search" class="search-field" :placeholder="lang == 1 ? '搜索' : 'Search'" v-model="search" /></label>
										<label><input type="button" class="search-submit" :value="lang == 1 ? '搜索' : 'Search'" @click="onSubmit"></label>
									</form>
								</aside>
								<aside id="recent-posts-1" class="widget widget_recent_entries wow fadeInDown animated" data-wow-delay="0.4s">
									<div class="section-header wow fadeInDown animated" data-wow-delay="0.4s">
										<h3 class="widget-title">{{lang == 1 ? '近期文章' : 'Latest Release' }}</h3></div>
									<ul>
										<li v-for="item in right">
											<router-link :to="{name:'article',params: { id: item.article_id }}">{{item.title}}</router-link>
										</li>
									</ul>

								</aside>
							</div>
						</div>
						<!--Sidebar Section-->
					</div>
				</div>
			</section>
		</div>
	</div>
</template>

<script>
	import { addContactUs, getArticle } from '../api/api';
	export default {
		data() {
			return {
				loading: false,
				search: '',
				name: '',
				email: '',
				phone: '',
				company: '',
				message: '',
				attachment: '',
				right: [],
				urls: '',
				home: ''
			};
		},
		props: ['lang'],
		methods: {
			onSubmit() {
				this.$router.push({
					name: 'search',
					params: {
						search: this.search
					}
				})
			},
			onUpload() {
				let that = this;
				var files = $('#upload')[0].files //获取上传的文件列表
				var formData = new FormData(); //新建一个formData对象
				formData.append("file", files[0]); //append()方法添加字段
				$.ajax({
					url: "http://admin.brlsea.org/api/common/upload",
					type: 'post',
					data: formData,
					processData: false, //必填 必须false 才会避开jq对formdata的默认处理 XMLHttpRequest才会对formdata进行正确处理  否则会报Illegal invocation错误
					contentType: false, //必填 必须false 才会加上正确的Content-Type
					success: function(res) {
						that.loading = false;
						if(res.code == 1) {
							$("#attachment").val(res.data.url);
						}
					}
				})

			},
			onRegistPost() {
				let that = this;
				$.ajax({
					type: "POST",
					dataType: "json",
					url: "http://admin.brlsea.org/api/index/addContactUs",
					data: $('#submit').serialize(),
					success: function(res) {
						that.loading = false;
						alert(res.msg);
					}
				});
			},
			onGetArticleRight() {
				let that = this;
				getArticle({
					lang: this.lang,
					page: 1,
					size: 3
				}).then(res => {
					if(res.code == 1) {
						that.right = res.data;
					}
				})
			},
		},
		created() {
			let that = this;
			this.onGetArticleRight();
			$('body').on('submit', '#submit', function() {
				event.preventDefault() //阻止form表单默认提交
				if(that.loading) {
					return false;
				}
				that.loading = true;
				that.onRegistPost()
			})
			$('body').on('change', '#upload', function() {
				event.preventDefault() //阻止form表单默认提交
				if(that.loading) {
					return false;
				}
				that.loading = true;
				that.onUpload()
			})
		},
		mounted() {
			this.home = $(".menu-item.active a").text();
		}
	};
</script>

<style scoped="scoped">
	.uploadbtn {
		display: inline-block;
		outline: none;
		color: #ffffff;
		border: 0 none;
		border-radius: 0px;
		display: inline-block;
		font-size: 0.875rem;
		height: 45px;
		margin: 0;
		background-color: #ce1b28;
		padding: 12px 22px;
		text-align: center;
		transition: all 0.4s ease 0s;
	}
	
	.uploadval {
		display: inline-block;
		outline: none;
		border: none;
		white-space: nowrap;
		overflow: hidden;
		text-overflow: ellipsis;
	}
</style>


// WEBPACK FOOTER //
// src/components/contact_us.vue